<template>
  <div>
    <transition name="mask">
      <div class="message-mask" @click="maskHide && cancel()" v-show="isShowMessageBox" style="z-index: 5001">
          <div class="popup popup-small message-dialog">
            <div class="popup-head">
              <span class="title">{{ title }}</span>
              <div class="popup-head-op" v-if="isShowCancelIcon">
                <a href="javascript:;" class="btn btn-shut popup-shut" @click="cancel">
                  <i class="mng icon-cross-stroke"></i>
                </a>
              </div>
            </div>
            <div class="popup-body">
              <div class="content content-simple">
                <div class="status-icon" v-if="icon && content !== ''">
                  <i :class="['mng', icon]"></i>
                </div>
                <slot><span v-html="content" class="text"></span></slot>
              </div>
            </div>
            <div class="popup-foot group">
              <a href="javascript:;" v-if="isShowCancelBtn" @click="cancel" class="btn btn-anti-default">{{ cancelVal }}</a>
              <a href="javascript:;" v-if="isShowConfirmBtn" @click="confirm" class="btn btn-solid-primary">{{ confirmVal  }}</a>
            </div>
          </div>
      </div>
    </transition>
    <div class="v-modal" tabindex="0" style="z-index: 5000;" v-show="isShowMessageBox"></div>
  </div>
</template>

<script>
let typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
}
export default {
  data() {
    return {
      isShowMessageBox: false,
      resolve: '',
      reject: '',
      promise: '' // 保存promise对象
    }
  },
  props: {
    isShowConfirmBtn: { // 是否显示确认按钮
      type: Boolean,
      default: true
    },
    isShowCancelBtn: {  // 是否展示取消按钮
      type: Boolean,
      default: true
    },
    isShowCancelIcon: { // 是否显示右上角关闭按钮
      type: Boolean,
      default: true
    },
    content: {
      type: String,
      default: ''
    },
    title: {   // 标题
      type: String,
      default: '提示'
    },
    confirmVal: {
      type: String,  // 确认文字
      default: '确定'
    },
    cancelVal: {   // 取消文字
      type: String,
      default: '取消'
    },
    maskHide: { // 是否可以点击蒙层关闭
      type: Boolean,
      default: false
    },
    type: {
      type: String,   // 类型
      default: ''
    },
    iconClass: {
      type: String,   // 自定义图标的类名，会覆盖type
      default: ''
    }
  },
  computed: {
    icon() {
      const {type, iconClass} = this
      return iconClass || (type && typeMap[type] ? `el-icon-${typeMap[type]}` : '')
    }
  },
  methods: {
    // 确定,将promise断定为resolve状态
    confirm() {
      this.isShowMessageBox = false
      this.resolve('confirm')
      this.remove()
    },
    // 取消,将promise断定为reject状态
    cancel() {
      this.isShowMessageBox = false
      this.reject('cancel')
      this.remove()
    },
    // 弹出messageBox,并创建promise对象
    showMsgBox() {
      this.isShowMessageBox = true
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
      // 返回promise对象
      return this.promise
    },
    remove() {
      setTimeout(() => {
        this.destroy()
      }, 100)
    },
    destroy() {
      this.$destroy()
      document.body.removeChild(this.$el)
    }

  }
}
</script>
<style lang='scss' scoped>
.message-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}

.message-mask::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: middle;
}

.message-dialog {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  overflow: hidden;
}

.content-simple {
  .status-icon {
    display: inline-block;
    margin-right: 8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    font-size: 24px;
    line-height: 1;
    vertical-align: middle;
  }
}

.content-simple > * {
  vertical-align: middle;
}

.status-icon {
  .el-icon-warning {
    color: #E6A23C;
  }

  .el-icon-success {
    color: #67C23A;
  }

  .el-icon-info {
    color: #909399
  }

  .el-icon-error {
    color: #F56C6C;
  }
}

/* 进入和出去的动画 来自elementUI 源码 */
.mask-enter-active, .mask-leave-active {
  transition: opacity .5s;
}

.mask-enter, .mask-leave-to /* .fade-leave-active, 2.1.8 版本以下 */
{
  opacity: 0
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.mask-enter-active {
  -webkit-animation: mask-in .3s;
  animation: mask-in .3s
}

.mask-leave-active {
  -webkit-animation: mask-out .3s;
  animation: mask-out .3s
}

@-webkit-keyframes mask-in {
  0% {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1
  }
}

@keyframes mask-in {
  0% {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1
  }
}

@-webkit-keyframes mask-out {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1
  }
  100% {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0
  }
}

@keyframes mask-out {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1
  }
  100% {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0
  }
}
</style>




// WEBPACK FOOTER //
// src/components/message-box/message-box.vue